import React, { useState } from 'react';
import { 
    Box,
    Portal,
} from '@mui/material';

import { useGridApiRef } from '@mui/x-data-grid-pro';
import CustomAvidColPopover from '../popover/CustomAvidColPopover';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import DataObjectIcon from '@mui/icons-material/DataObject';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import ReplayIcon from '@mui/icons-material/Replay';
import SaveIcon from '@mui/icons-material/Save';
import SettingsIcon from '@mui/icons-material/Settings';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import UndoIcon from '@mui/icons-material/Undo';

import PermissionGuard from '../../contexts/PermissionContext';

import ControlBar from '../structure/ControlBar';
import ControlButton from '../structure/ControlButton';
import MenuPopover from '../popover/MenuPopover';
import MenuListItem from '../menuitem/MenuListItem';
import BaseDivider from '../divider/BaseDivider'

import AleConfigPopover from '../popover/AleConfigPopover';
import CustomMetaPopover from '../popover/CustomMetaPopover';

export default function SyncConfigMenuBar(props) {
    const { 
        addVisibleConfigRows,
        config,
        configRef,
        customRows,
        deleteConfig,
        handleChange,
        menuRef,
        openMenu,
        setConfigRows,
        setCustomRows,
        setMenuContent,
        submitConfig,
        setUseTextEditor,
        undoConfig,
        addCustomField,
        addCustomRow
    } = props

    const openRevertMenu = (e) => {
        openMenu(e)
        setMenuContent(
            <div style={{ width: '200px'}}>
                <MenuListItem 
                    label={'Revert To Last Saved Config'}
                    icon={<UndoIcon style={{ color: 'grey' }} />}
                    onClick={() => undoConfig('revert')}
                />
                <MenuListItem
                    label={'Reset To Original Config'}
                    icon={<SettingsBackupRestoreIcon  style={{ color: 'grey' }} />}
                    onClick={() => undoConfig('reset')}
                />
            </div>
        )
        
    }

    const openConfigMenu = (e) => {
        openMenu(e)
        setMenuContent(
        <AleConfigPopover
            config={config}
            deleteConfig={deleteConfig}
            handleChange={handleChange}
        />
        )
    }

    const openCustomMetaMenu = (e) => {

        openMenu(e)
        setMenuContent(
            <CustomMetaPopover
                configRef={configRef}
                customRows={customRows}
                setConfigRows={setConfigRows}
                setCustomRows={setCustomRows}
            />
        )
    }


    const switchToTextEditor = () => {
        setUseTextEditor((prev) => !prev)
    }

    
    const saveConfig = () => {
        // Reform the datagrid into the format of the deliverable
        const rows = configRef.current.getSortedRows()
        let formattedRows = {}
        for (let row of rows){
            formattedRows[row.metadataName] = {
                avid_key: row.configName,
                sync_type: row.sync_type
            }
        }

        const customObj = customRows.reduce((acc, item) => {
            acc[item.metadataName] = item.customString
            return acc
        }, {})
        const body =  {
            ...config,
            data: formattedRows,
            args: {
                ...config.args,
                customColumn: customObj
            }
        }
        submitConfig(body)
    }

    const openCustomColMenu = (e) => {

        openMenu(e)
        setMenuContent(
            <CustomAvidColPopover
                configRef={configRef}
                customRows={customRows}
                setConfigRows={setConfigRows}
                setCustomRows={setCustomRows}
                addCustomRow={addCustomRow}
            />
        )
    }



    return (
        <React.Fragment>
            <Portal container={menuRef.current}>

                <BaseDivider />
                <ControlButton
                    title='Save Changes'
                    clicked={saveConfig}
                    // disabled={Object.keys(config).length > 0 ? false : true}
                >
                    <SaveIcon style={{fill: 'white'}} />
                </ControlButton>
                <PermissionGuard permission={['update:deliverables']}>
                <ControlButton
                    title='Revert to an older config'
                    clicked={openRevertMenu}
                    // disabled={Object.keys(config).length > 0 ? false : true}
                >
                    <Box
                        display="flex"
                        paddingLeft="5px"
                        justifyContent="center"
                        alignItems="center"
                        pr={0.3}
                    >
                        <ReplayIcon style={{fill: 'white'}} />
                        <ArrowDropDownIcon style={{fill: "white"}} sx={{ fontSize: 18, ml: -0.4 }}/>
                    </Box>
                </ControlButton>
                </PermissionGuard>
                <BaseDivider />
                <ControlButton
                    title='Add Custom Field'
                    clicked={openCustomColMenu}
                    // disabled={Object.keys(config).length > 0 ? false : true}
                >
                    <PlaylistAddIcon style={{fill: 'white'}} />
                </ControlButton>
                <BaseDivider />
            </Portal>
        </React.Fragment>
    );
}
